module.exports = __webpack_public_path__ + "img/thumbnail-spfcu.be42c0e2.jpg";